var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{},[_c('div',{staticClass:"mt-3"},[_c('div',{staticClass:"text-center",attrs:{"id":"banner"}},[_c('h2',{staticClass:"text-light text-center align-middle"},[_vm._v(" "+_vm._s(_vm.orgTitle)+" ")]),_c('p',{staticClass:"lead text-center text-light"},[_vm._v(" "+_vm._s(_vm.orgDevise)+" ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }